import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Dialog, DialogContent, Box, LinearProgress } from '@mui/material';
import { Button, Typography, colors } from '@leapeasy/ui-kit';
import guideData from 'data/dummy/guideData';

const { guideSteps } = guideData;

export const GuideSlider = ({ open, onClose }) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = guideSteps.length;
  const step = guideSteps[activeStep];
  const isLastStep = activeStep >= maxSteps - 1;

  useEffect(() => {
    if (!open) {
      setActiveStep(0);
    }
  }, [open]);

  const handleClose = () => {
    setActiveStep(0);
    onClose();
  };

  if (!step) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box
          sx={{
            aspectRatio: '16 / 9',
            bgcolor: '#000',
            borderRadius: '8px',
            overflow: 'hidden',
            mb: 2,
          }}
        >
          <ReactPlayer
            key={step.videoURL}
            url={step.videoURL}
            width="100%"
            height="100%"
            controls
            playing={open}
            playsinline
          />
        </Box>

        <Typography variant="h6" style={{ color: colors.purple[900], fontWeight: 500 }}>
          {step.title}
        </Typography>

        <LinearProgress
          variant="determinate"
          value={maxSteps ? ((activeStep + 1) / maxSteps) * 100 : 0}
          sx={{ my: 2, borderRadius: '4px' }}
        />

        <Box display="flex" justifyContent="space-between" gap="12px">
          <Button
            variant="tertiary"
            size="small"
            disabled={activeStep === 0}
            onClick={() => setActiveStep((prev) => Math.max(0, prev - 1))}
          >
            Back
          </Button>
          {isLastStep ? (
            <Button variant="primary" size="small" onClick={handleClose}>
              Done
            </Button>
          ) : (
            <Button
              variant="primary"
              size="small"
              onClick={() => setActiveStep((prev) => Math.min(maxSteps - 1, prev + 1))}
            >
              Next
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
